// store/productStore.ts
import { create } from "zustand";
import { Product } from "../types/product";


interface ProductState {
    products: Product[];
    setProducts: (products: Product[]) => void;
    addProduct: (product: Product) => void;
    getProductById: (id: string) => Product | undefined;
}

export const useProductStore = create<ProductState>((set, get) => ({
    products: [],
    setProducts: (products) => set({ products }),
    addProduct: (product) => set((state) => ({ products: [...state.products, product] })),
    getProductById: (id) => get().products.find((p) => p.id === id),
}));
